import React, { useState } from 'react';

import PropTypes from 'prop-types';
import {
  Button, Collapse, Link, Menu, MenuItem,
  Slide,
} from '@mui/material';
import CollapseIconSVGR from '../../assets/svgr/CollapseIconSVGR';
import './styles.scss';
import ArrowDownIconSVGR from '../../assets/svgr/ArrowDownIconSVGR';
import ArrowUpIconSVGR from '../../assets/svgr/ArrowUpIconSVGR';
import CloseIconSVGR from '../../assets/svgr/CloseIconSVGR';

const CollapsedMenu = ({ items }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openSubLinks, setOpenSubLinks] = useState(false);

  const handleClick = (e) => setAnchorEl(e.currentTarget);

  const handleClose = (link) => {
    if (link.subLinks?.length > 0) {
      setOpenSubLinks(!openSubLinks);
    } else {
      setAnchorEl(null);
    }
  };

  const getMenuItems = (menuItem) => menuItem.name.map((name) => {
    let symbolFound = false;

    if (name === 'North American®') {
      name = 'North American';
      symbolFound = true;
    }

    return (
      <span className={name === 'Home' ? ' menu-item-active' : ''}>
        {name}
        {symbolFound && <sup className='menu-item-container-sub-symbol-bottom'>®</sup>}
      </span>
    );
  });

  const displayMenuItem = (menuItem) => {
    if (menuItem.subLinks?.length) {
      return (
        <span className='menu-item-container'>
          <span className='menu-item-with-sub-items-container-text'>
            {getMenuItems(menuItem)}
          </span>
          <span className='menu-item-container-arrow-icon-container'>
            <span className='menu-item-container-arrow-icon'>
              {openSubLinks && <ArrowUpIconSVGR />}
              {!openSubLinks && <ArrowDownIconSVGR />}
            </span>
          </span>
        </span>
      );
    }

    return (
      <span className='menu-item-container-text'>
        {getMenuItems(menuItem)}
      </span>
    );
  };

  const handleCloseMenu = () => setAnchorEl(null);

  return (
    <>
      <div className='drawer-overlay' data-drawer-target-string='#mobile-drawer' />
      <Button
        onClick={handleClick}
      >
        <span className='icon-set'>
          <CollapseIconSVGR />
        </span>
      </Button>
      <Menu
        className='responsive-menu'
        anchorEl={anchorEl}
        PaperProps={{
          className: 'responsive-menu-container',
        }}
        TransitionComponent={Slide}
        transitionDuration={177}
        TransitionProps={
          {
            direction: 'left',
            easing: 'ease-in',
          }
        }
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <div className='menu-item-close-icon'>
          <Button onClick={handleCloseMenu} className='animated-button'>
            <CloseIconSVGR />
          </Button>
        </div>
        {items.map((link) => (
          <>
            <MenuItem
              component={Link}
              href={link.subLinks?.length > 0 ? '#' : link.url}
              key={link.name}
              onClick={() => handleClose(link)}
            >
              {displayMenuItem(link)}
            </MenuItem>
            <Collapse in={openSubLinks} timeout='auto' unmountOnExit>
              <div className='header-sub-link'>
                {link.subLinks?.map(({ name, url }) => (
                  <a href={url} className='header-sub-link' key={url}>
                    {name.map((text) => (
                      <p key={text}>{text}</p>
                    ))}
                  </a>
                ))}
              </div>
            </Collapse>
          </>
        ))}
      </Menu>
    </>
  );
};

CollapsedMenu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape()),
};

CollapsedMenu.defaultProps = {
  items: undefined,
};

export default CollapsedMenu;
